module.exports = __webpack_public_path__ + "static/img/02062B_C_03_20170813_LC.272f45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02062B_C_03_20170813_LC.png
// module id = 7aPN
// module chunks = 0